export const defaultShareImage =
  'https://storage.googleapis.com/tock-public-assets/tock-social-share/04-20-22-Tock-Share-Graphic.jpg';
export const defaultWineShopShareImage =
  'https://storage.googleapis.com/tock-public-assets/brand-assets/shop/share_graphic/wine-shop-share%403x.jpg';

export const FACEBOOK_APP_ID = '319973538191556';

// Currently configured as an OAuth2 client ID called Oauth proxy frame
// See https://console.cloud.google.com/apis/credentials/oauthclient/1045216867968-g08349mevvhe8g5ehng7cfp5mtltca50.apps.googleusercontent.com
export const GOOGLE_CLIENT_ID =
  '1045216867968-g08349mevvhe8g5ehng7cfp5mtltca50.apps.googleusercontent.com';

export const TOCK_INSTAGRAM_URL = 'https://www.instagram.com/exploretock';
export const TOCK_TWITTER_URL = 'https://twitter.com/tock';
export const TOCK_LINKED_IN_URL = 'https://www.linkedin.com/company/tock';
export const TOCK_FACEBOOK_URL = 'https://www.facebook.com/exploretock';
